import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { fetchConsumerMe } from '../../util/rematchApi';
import * as log from '../../util/log';

const ConsumerIdentitySync = () => {
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  const currentUserId = useSelector(state => state.user?.currentUser?.id?.uuid);
  const attemptedUserId = useRef(null);

  useEffect(() => {
    if (!isAuthenticated) {
      attemptedUserId.current = null;
      return undefined;
    }

    if (!currentUserId || attemptedUserId.current === currentUserId) {
      return undefined;
    }

    let active = true;
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    attemptedUserId.current = currentUserId;
    const synchronizeIdentity = async () => {
      try {
        const identity = await fetchConsumerMe({ signal: controller?.signal });
        if (active && identity?.sharetribeUserId !== currentUserId) {
          throw new Error('ReMatch returned an identity for a different Sharetribe user.');
        }
      } catch (error) {
        if (active && !controller?.signal.aborted) {
          attemptedUserId.current = null;
          log.error(error, 'rematch-consumer-identity-sync-failed', { currentUserId });
        }
      }
    };

    void synchronizeIdentity();
    return () => {
      active = false;
      controller?.abort();
    };
  }, [currentUserId, isAuthenticated]);

  return null;
};

export default ConsumerIdentitySync;
